import {
    Vector3,
    PerspectiveCamera,
    Object3D,
    Euler,
    Quaternion,
    Matrix4
} from 'three'
import { OrbitControls } from './OrbitControls' //'three/examples/jsm/controls/orbitcontrols'
import { gsap } from 'gsap'

import { values } from '../components/values'
import { getRealSize, isM, randomNum, lerp } from '../components/alpha'
// import { lerp } from 'three/src/math/mathutils'
import { PopsController } from './popsController'


// ------------------------------------------------------------


export class CameraController {

    #_DOMelem
    #_camera
    #_target
    #_dofEffect

    #_camData = {
        fov: 65,
        far: 700,
        pos: {x: 0, y: 13, z: -15}, // Para estadio
        lookAt: {x: 0, y: 8, z: 4}
    }

    #_splashScreenGsap = undefined

    #_enableFollow = false
    #_orbitControls
    #_currentPosition = new Vector3().copy(this.#_camData.pos)
    #_currentLookAt = new Vector3().copy(this.#_camData.lookAt)

    //

    constructor(params) {
        this.#_DOMelem = params.DOMelem

        const size = getRealSize(this.#_DOMelem)
        this.#_camera = new PerspectiveCamera( this.#_camData.fov, size.w/size.h, 0.1, this.#_camData.far )
        this.#_camera.position.copy( this.#_camData.pos )

        // OrbitControls
        this.#_orbitControls = new OrbitControls(this.#_camera, this.#_DOMelem)
        this.#_orbitControls.enabled = false
        this.#_orbitControls.target = new Vector3().copy(this.#_camData.lookAt)
        this.#_orbitControls.enablePan = false
        this.#_orbitControls.enableZoom = false
        // this.#_orbitControls.enableDamping = true
        this.#_orbitControls.minDistance = 15
        this.#_orbitControls.maxDistance = 20
        this.#_orbitControls.minPolarAngle = Math.PI / 2.55
        this.#_orbitControls.maxPolarAngle = Math.PI / 2.25
        this.#_orbitControls.update()
    }

    //

    get camera() {
        return this.#_camera
    }

    set enableFollow(value) {
        this.#_enableFollow = value
    }
    get enableFollow() {
        return this.#_enableFollow
    }

    set target(obj) {
        this.#_target = obj
    }
    get target() {
        return this.#_target
    }


    // set dofEffect(ef) {
    //     this.#_dofEffect = ef
    // }
    // get dofEffect() {
    //     return this.#_dofEffect.dof
    // }

    //

    splashScreenState() {

        const duration = 6

        const a = [
            [
                new Vector3(5, 45, 150), new Vector3(0, 40, 180),
                new Vector3(0, 70, 60), new Vector3(0, 25, 80)
            ],
            [
                new Vector3(110, 50, 120), new Vector3(110, 40, 150),
                new Vector3(155, 65, 70), new Vector3(105, 45, 30)
            ],
            [
                new Vector3(50, 100, -50), new Vector3(0, 50, 0),            // LookAt
                new Vector3(-175, 200, -250), new Vector3(175, 125, -250)   // Position
            ],
        ]

        const cam = this.#_camera

        let l = 0
        const play = (array) => {

            cam.position.copy(array[2])
            cam.lookAt(array[0])
            cam.updateProjectionMatrix()

            this.#_splashScreenGsap = gsap.to({x:0}, {
                x: 1,
                duration,
                ease: 'power1.inOut',
                onUpdate() {
                    const newLookAt = new Vector3().lerpVectors( array[0],  array[1], this.targets()[0].x)
                    cam.lookAt(newLookAt)
                    const newPosition = new Vector3().lerpVectors( array[2],  array[3], this.targets()[0].x)
                    cam.position.copy(newPosition)
                },
                onComplete() {
                    play(a[l % a.length])
                }
            })

            l++
        }

        play( a[l] )

    }
    panning(type, duration, delay) {

        if (this.#_splashScreenGsap) {
            this.#_splashScreenGsap.pause()
            this.#_splashScreenGsap = undefined
        }


        const cam = this.#_camera
        // const dofEffect = this.#_dofEffect


        // Types = Data for panning
        const estadioPan = [
            new Vector3(0, 50, 110), new Vector3().copy( this.#_camData.lookAt ),
            new Vector3(0, 60, 80), new Vector3().copy( this.#_camData.pos ),
            75, this.#_camData.fov
        ]
        const estadioAltPan = [
            new Vector3(120, 105, -160), new Vector3().copy( this.#_camData.lookAt ),  // LookAt
            new Vector3(70, 125, -175), new Vector3().copy( this.#_camData.pos ),   // Position
            50, this.#_camData.fov
        ]


        let camerinoCamData = [
            new Vector3(0, 50, 110), new Vector3(0, 6, 0),
            new Vector3(0, 60, 80), new Vector3(0, 9, -25),
            75, 35
        ]
        if(isM) {
            camerinoCamData[1] = new Vector3(-2, 5, 0) //Lookat
            camerinoCamData[3] = new Vector3(-6, 9, -28) //Position
        }

        let cameStep1 = [
            new Vector3(-3, 5, 0), camerinoCamData[1],
            new Vector3().copy(cam.position), camerinoCamData[3],
            45, 35
        ]
        if(isM) cameStep1[0] = new Vector3(0, 0.5, 0)

        const alt = randomNum(0, 2)
        let cameStep2 = [
            camerinoCamData[1], cameStep1[0],
            new Vector3().copy(cam.position), alt == 0 ? new Vector3(4, 7, -17) : new Vector3(-4, 7, -17),
            35, 45
        ]
        if(isM) cameStep2[3] = alt == 0 ? new Vector3(4, 14, -33) : new Vector3(-4, 14, -33)


        //
        let array
        switch (type) {
            case 'Estadio':
                array = estadioPan
                break;
            case 'EstadioAlt':
                array = estadioAltPan
                break;
            // case 'Camerino':
            //     array = camerinoCamData
            //     break;
            case 'CamStep1':
                array = cameStep1
                break;
            case 'CamStep2':
                array = cameStep2
                break;

            default:
                console.warn('No panType match')
                break;
        }

        //
        cam.position.copy(array[2])
        cam.lookAt(array[0])
        cam.fov = array[4]
        cam.updateProjectionMatrix()

        //
        gsap.to({x:0}, {
            x: 1,
            delay, duration,
            ease: 'power1.inOut',
            onUpdate() {
                const x = this.targets()[0].x

                const newPosition = new Vector3().lerpVectors( array[2],  array[3], x)
                cam.position.copy(newPosition)

                const newLookAt = new Vector3().lerpVectors( array[0],  array[1], x)
                cam.lookAt(newLookAt)

                cam.fov = lerp(array[4], array[5], x)
                cam.updateProjectionMatrix()

                //
                // if(type == 'Camerino') dofEffect.dof.bokehScale = lerp( dofEffect.bokeh[0], dofEffect.bokeh[1], x)
            },
            onComplete() {
                // window.avatar.toggleControls(false)
                window.avatar.toggleControls(true)
            }
        })

    }
    questionCloseUp(npcPos, avatarPos) {

        const centerPoint = new Vector3().copy(avatarPos)
        const pointToRotate = new Vector3().copy(npcPos)

        // Where the camera will lookAt
        const halfPoint = new Vector3().addVectors(pointToRotate, centerPoint).divideScalar(2)
        halfPoint.y = this.#_camData.lookAt.y - 3

        //

        const angle = -110

        const displacement = pointToRotate.clone().sub(centerPoint)
        const rotationMatrix = new Matrix4().makeRotationY(angle * Math.PI / 180)

        displacement.applyMatrix4(rotationMatrix)

        const rotated = centerPoint.clone().add(displacement)
        rotated.y = this.#_camData.pos.y - 3


        const animated = false

        if(animated) {
            const cam = this.#_camera
            const tempLookAt = this.#_orbitControls.target

            gsap.to({x:0}, {
                x: 1,
                duration: 2,
                ease: 'power1.inOut',
                onUpdate() {
                    const x = this.targets()[0].x
                    const newPosition = new Vector3().lerpVectors( cam.position, rotated, x)
                    cam.position.copy(newPosition)
                    const newLookAt = new Vector3().lerpVectors( tempLookAt, halfPoint, x)
                    cam.lookAt(newLookAt)
                    cam.updateProjectionMatrix()
                },
            })
        } else {
            this.#_camera.position.copy(rotated)
            this.#_camera.lookAt(halfPoint)
        }
    }

    //

    _calculateOffset(vec3) {
        const offset = new Vector3().copy(vec3)
        offset.add(this.#_target.position)
        return offset
    }

    followTarget(delta) {

        if ( !this.#_enableFollow || !this.#_target ) return

        const idealOffset = this._calculateOffset(this.#_camData.pos)
        const idealLookAt = this._calculateOffset(this.#_camData.lookAt)

        // Calculate
        const t = 1 - Math.pow(0.05, delta)
        this.#_currentPosition.lerp( idealOffset, t )
        this.#_currentLookAt.lerp( idealLookAt, t )

        // Update
        this.#_orbitControls.target = idealLookAt
        this.#_orbitControls.update()

    }
}